import { render } from "./FormGridLocal.vue?vue&type=template&id=7ca9494c&ts=true"
import script from "./FormGridLocal.ts?vue&type=script&lang=ts&external"
export * from "./FormGridLocal.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__